<template>
  <div class="content-container" v-loading="loading">
    <el-scrollbar>
      <div class="ala-container">
        <div class="top-wrap flex">
          <div class="left">
            <div class="title">IDMIC {{ current_round.name }} {{ $t('niandushenhe') }}</div>
          </div>
          <div class="right">
            <!-- <el-select v-model="round_id" placeholder="请选择轮次">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </div>
        </div>
        <div class="top-tab">
            <div :class="review_option==='first'? 'active tab-item':'tab-item' " @click="toChange('first')">
                {{ $t('firstReview') }}
            </div>
            <div :class="review_option==='second'? 'active tab-item':'tab-item' " @click="toChange('second')">
                {{$t('secondReview')}}
            </div>
        </div>
        <!-- 初审 -->
        <div class="content-wrap no-mar" v-if="review_option==='first'">
          <div class="round-info flex" >
            <div class="title">
                <span v-if="first_status==='un_start'">{{ $t('firstReviewUnstart') }}</span>
                <span v-else-if="first_status==='inTime'">{{$t('firstReviewing')}}</span>
                <span v-else-if="first_status==='end'" style="color: red;">{{ $t('firstReviewEnd') }}</span>
            </div>
            <div class="time-box" style="color: red;" v-if="first_status==='end'">
              {{ $t('firstReviewTime') }} {{current_round.first_review_start_time}}～{{ current_round.first_review_end_time }}
            </div>
            <div class="time-box" v-else>
              {{ $t('firstReviewTime') }} {{current_round.first_review_start_time}}～{{ current_round.first_review_end_time }}
            </div>
          </div>
          <div class="empty-box" v-if="first_status === 'un_start'">
            <el-empty :description="$t('firstReviewUnstart')"></el-empty>
          </div>
          <div class="group-list" v-else>
            <el-row :gutter="30" type="flex">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in first_group" :key="item.id">
                <div class="item" >
                  <div class="content-item">
                    <div class="label">{{ $t('groupNum') }}</div>
                    <div class="desc">{{ item.name }}</div>
                  </div>
                  <!-- <div class="content-item">
                    <div class="label">评审成员</div>
                    <div class="desc">
                        <span class="teacher-name" v-for="teacher in item.reviewers" :key="teacher.id">{{ teacher.name }}</span>
                    </div>
                  </div> -->
                  <div class="content-item">
                    <div class="label">{{ $t('wordCount') }}</div>
                    <div class="desc">{{ item.work_count }}</div>
                  </div>
                  <div class="bottom-box flex">
                    <div class="left">
                      <div class="content-item">
                        <div class="label">{{ $t('reviewProcess') }}</div>
                        <div class="progress-box">
                          <el-progress :percentage="item.progress" :color="customColorMethod(item.progress)"></el-progress>
                        </div>
                      </div>
                    </div>
                    <div class="right-btn">
                      <el-button v-if="item.progress == 0 && first_status!='end'" round type="primary" @click="toReview(item)">{{ $t('startReview') }}</el-button>
                      <el-button v-if="item.progress > 0 && item.progress < 100 && first_status!='end'" plain round type="primary" @click="toReview(item)">{{ $t('continueReview') }}</el-button>
                      <el-button v-if="item.progress == 100 || first_status==='end'" round plain type="success" @click="toReview(item)">{{ $t('seeDetail') }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          
        </div>
        <!-- 复审 -->
        <div class="content-wrap no-mar" v-if="review_option==='second'">
          <div class="round-info flex" >
            <div class="title">
                <span v-if="second_status==='un_start'">{{ $t('secondReviewUnstart') }}</span>
                <span v-else-if="second_status==='inTime'">{{ $t('secondReviewing') }}</span>
                <span v-else-if="second_status==='end'" style="color: red;">{{ $t('secondReviewEnd') }}</span>
            </div>
            <div class="time-box" style="color: red;" v-if="second_status==='end'">
              {{$t('secondReviewTime')}} {{current_round.second_review_start_time}}～{{ current_round.second_review_end_time }}
            </div>
            
          </div>
          <div class="empty-box" v-if="second_status === 'un_start'">
            <el-empty :description="$t('secondReviewUnstart')"></el-empty>
          </div>
          <div class="group-list" v-else>
            <el-row :gutter="30" type="flex">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in second_group" :key="item.id">
                <div class="item" >
                  <div class="content-item">
                    <div class="label">{{ $t('groupNum') }}</div>
                    <div class="desc">{{ item.name }}</div>
                  </div>
                  <!-- <div class="content-item">
                    <div class="label">评审成员</div>
                    <div class="desc">
                        <span class="teacher-name" v-for="teacher in item.reviewers" :key="teacher.id">{{ teacher.name }}</span>
                    </div>
                  </div> -->
                  <div class="content-item">
                    <div class="label">{{ $t('wordCount') }}</div>
                    <div class="desc">{{ item.work_count }}</div>
                  </div>
                  <div class="bottom-box flex">
                    <div class="left">
                      <div class="content-item">
                        <div class="label">{{ $t('reviewProcess') }}</div>
                        <div class="progress-box">
                          <el-progress :percentage="item.progress" :color="customColorMethod(item.progress)"></el-progress>
                        </div>
                      </div>
                    </div>
                    <div class="right-btn">
                      <el-button v-if="item.progress == 0 && second_status!='end'" round type="primary" @click="toReview(item)">{{ $t('startReview') }}</el-button>
                      <el-button v-if="item.progress > 0 && item.progress < 100 && second_status!='end'" plain round type="primary" @click="toReview(item)">{{ $t('continueReview') }}</el-button>
                      <el-button v-if="item.progress == 100 || second_status==='end'" round plain type="success" @click="toReview(item)">{{ $t('seeDetail') }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import  { apiAllRound , apiCurrentRound ,apiReviewGroup } from "../plugins/api";
import  {  checkRoundTime } from "../plugins/common";
export default {
  data() {
    return {
      round_id: "",
      options: [],
      current_round:{},
      first_status:"",
      second_status:"",
      review_group:[],
      first_group:[],
      second_group:[],
      review_option:"",
      is_review:"",
      loading:true,
    };
  },
  async mounted() {
    //await this.getAllRound()
    await this.getCurrentRound()
    await this.getReviewGroup()
    this.loading = false

    if(this.second_status == 'inTime' || this.second_status==='end'){
      this.review_option = 'second'
    }else{
      this.review_option = 'first'
    }
  },
  methods: {
    async getAllRound(){
        let res = await apiAllRound();
        if (res.code === 200) {
            this.options = res.data;
            console.log(this.options);
        }
    },
    
    async getCurrentRound(){
        let res = await apiCurrentRound();
        if (res.code === 200) {
            this.current_round = res.data;
            this.first_status = checkRoundTime(this.current_round.first_review_start_time,this.current_round.first_review_end_time)
            this.second_status = checkRoundTime(this.current_round.second_review_start_time,this.current_round.second_review_end_time)
            console.log(111,this.first_status);
        }
    },
    async getReviewGroup(){
        let res = await apiReviewGroup();
        if (res.code === 200) {
            this.review_group = res.data;
            for (let item of this.review_group) {
               item.progress = parseFloat((item.haveResult/item.work_count*100).toFixed(0))
               if(item.option === "first"){
                    this.first_group.push(item)
                    console.log(111,this.first_group);
               }else if(item.option === "second"){
                    this.second_group.push(item)
               }
            }
            // if(this.first_status === "inTime"){
            //     this.review_group = this.first_group
            // }else if(this.first_status === "un_start"){
            //     this.review_group = []
            // }else if(this.first_status === "end"&&this.second_status === "un_start"){
            //     this.review_group = this.first_group
            // }else if(this.second_status === "inTime"){
            //     this.review_group = this.second_group
            // }

        }
    },
    toChange(data){
        this.review_option = data
    },
    toReview(data){
        if(data.progress < 100){
            this.is_review = '2'
        }else{
            this.is_review = '1'
        }
        this.$router.push(`/review?round_id=${this.current_round.id}&review_option=${this.review_option}&review_group_id=${data.id}&is_review=${this.is_review}`);
    },
    customColorMethod(data){
        if (data < 100) {
          return '#000';
        } else {
          return '#67C23A';
        }
    },
    
    
  },
};
</script>
